import { Button } from 'antd';
import './Empty.scss';

export default function Empty(props) {
    return (
        <div className="render-no-data">
            <img
                className="img"
                src={require('@/assets/img/hdd/empty.png').default}></img>
            <div className="tip-word">{props.tip}</div>
            <Button type="primary" onClick={props.handleCreate}>
                {props.btnWord}
            </Button>
        </div>
    );
}
